import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { accessoryGet } from "@/common/api/rest/accessory/accessory";

import type { AccessoryType } from "@/common/types/accessory/accessory";

import TabAccessoryInfos from "@/components/tabs/accessory/infos.vue";
import TabAccessoryDetails from "@/components/tabs/accessory/details.vue";
import TabAccessorySlug from "@/components/tabs/accessory/slug.vue";
import TabAccessoryImages from "@/components/tabs/accessory/images.vue";
import TabAccessoryName from "@/components/tabs/accessory/name.vue";
import TabAccessoryConsole from "@/components/tabs/accessory/console.vue";
import TabAccessoryRelated from "@/components/tabs/accessory/related.vue";
import TabAccessoryVersions from "@/components/tabs/common/versions.vue";

import { breadcrumbSimple, iconMenu, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: '[tab]',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const selectedTab = ref("infos");
const accessoryData = ref<AccessoryType | null>(null);

const accessoryId = computed(() => route.params.item as string);

const breadcrumbList = computed(() => [
  {
    key: "collections",
    label: t("common.labels.collections"),
    url: `/collection`,
  },
  {
    key: "accessory",
    label: t("collection.labels.accessories"),
    url: `/collection/accessory`,
  },
  {
    key: "edit",
    label: accessoryData.value?.name ?? "...",
  },
]);

const menuList = computed(() => [
  {
    key: "infos",
    icon: "field",
    label: t("collection.labels.infos"),
    url: `/collection/accessory/${accessoryId.value}/infos`,
  },
  {
    key: "name",
    icon: "no-image",
    label: t("common.labels.other_names"),
    url: `/collection/accessory/${accessoryId.value}/name`,
  },
  {
    key: "slug",
    icon: "no-image",
    label: t("slug.labels.slugs"),
    url: `/collection/accessory/${accessoryId.value}/slug`,
  },
  {
    key: "image",
    icon: "no-image",
    label: t("collection.labels.images"),
    url: `/collection/accessory/${accessoryId.value}/image`,
  },
  {
    key: "details",
    icon: "no-image",
    label: t("collection.labels.details"),
    url: `/collection/accessory/${accessoryId.value}/details`,
  },
  {
    key: "console",
    icon: "no-image",
    label: t("collection.labels.consoles"),
    url: `/collection/accessory/${accessoryId.value}/console`,
  },
  {
    key: "related",
    icon: "gamepad",
    label: t("collection.labels.related"),
    url: `/collection/accessory/${accessoryId.value}/related`,
  },
  {
    key: "versions",
    icon: "no-image",
    label: t("collection.labels.versions"),
    url: `/collection/accessory/${accessoryId.value}/versions`,
  },
]);

function back() {
  router.push(`/collection/accessory`);
}

async function changeMenu(url: string) {
  await fetchData();
  router.push(url);
}

// accessory
async function fetchData() {
  await accessoryGet(accessoryId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        accessoryData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => route.params.tab,
  () => {
    selectedTab.value = route.params.tab as string;
  },
  {
    immediate: true,
  },
);

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "gamepad",
            size: "2rem"
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" EDITAR ACESSÓRIO ", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default w-8 h-8",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: selectedTab.value,
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs", "active"]),
        (accessoryData.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (selectedTab.value === 'infos')
                ? (_openBlock(), _createBlock(TabAccessoryInfos, {
                    key: 0,
                    "accessory-id": accessoryId.value,
                    accessory: accessoryData.value,
                    "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (fetchData()))
                  }, null, 8, ["accessory-id", "accessory"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'slug')
                ? (_openBlock(), _createBlock(TabAccessorySlug, {
                    key: 1,
                    "accessory-id": accessoryId.value
                  }, null, 8, ["accessory-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'details')
                ? (_openBlock(), _createBlock(TabAccessoryDetails, {
                    key: 2,
                    "accessory-id": accessoryId.value
                  }, null, 8, ["accessory-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'name')
                ? (_openBlock(), _createBlock(TabAccessoryName, {
                    key: 3,
                    "owner-id": accessoryId.value
                  }, null, 8, ["owner-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'console')
                ? (_openBlock(), _createBlock(TabAccessoryConsole, {
                    key: 4,
                    "owner-id": accessoryId.value
                  }, null, 8, ["owner-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'related')
                ? (_openBlock(), _createBlock(TabAccessoryRelated, {
                    key: 5,
                    "accessory-id": accessoryId.value
                  }, null, 8, ["accessory-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'versions')
                ? (_openBlock(), _createBlock(TabAccessoryVersions, {
                    key: 6,
                    "owner-type": "accessory",
                    "owner-id": accessoryId.value
                  }, null, 8, ["owner-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'image')
                ? (_openBlock(), _createBlock(TabAccessoryImages, {
                    key: 7,
                    "accessory-id": accessoryId.value
                  }, null, 8, ["accessory-id"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})